import React, { useEffect, useState, ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '@actions';
import useTodoActions from '@hooks/useTodoActions';
import { SuccessModal } from 'vl-common/src/components/Modals/CustomModals/Success';
import { ToDoItem } from '@components/Patients/ToDos/ToDos';

interface CompleteNextSurveyProps {
  caseId: number | null;
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  continueDataTestid: string;
  title: string;
  noNextSurveyText?: ReactNode;
  onCancelModal?: () => void;
  subtitle?: ReactNode;
  closeSideEffect?: () => void;
}

const StartNextSurveyModal = ({
  caseId,
  showModal,
  setShowModal,
  continueDataTestid,
  title,
  noNextSurveyText,
  onCancelModal,
  subtitle,
  closeSideEffect
}: CompleteNextSurveyProps) => {
  const [nextSurvey, setNextSurvey] = useState<ToDoItem[]>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const getNextSurvey = async () => {
      if (caseId) {
        const res = await dispatch(actions.getNextSurvey(caseId));
        setNextSurvey(res?.todo);
      }
    };
    getNextSurvey().then();
  }, [caseId, dispatch, showModal]);

  const todoActions = useTodoActions(nextSurvey);

  const onCancel = () => {
    setShowModal(false);
    closeSideEffect?.();
    onCancelModal?.();
  };

  const onOK = () => {
    if (todoActions?.length > 0 && todoActions[0].action) {
      todoActions[0].action();
    } else {
      setShowModal(false);
      closeSideEffect?.();
      onCancelModal?.();
    }
  };

  const content = (
    <>
      {subtitle && (
        <>
          {subtitle}
          <hr />
        </>
      )}
      <p>
        {todoActions?.length > 0 ? `Please press continue to ${todoActions[0].text} for your case` : noNextSurveyText}
      </p>
    </>
  );

  return (
    <SuccessModal
      open={showModal}
      title={title}
      cancelText="Return to dashboard"
      okText={todoActions?.length > 0 ? 'Continue' : ''}
      continueDataTestid={continueDataTestid}
      data-testid="return-to-dashboard"
      subTitle={content}
      onCancel={onCancel}
      onOk={onOK}
    >
      <div style={{ margin: '20px 0' }} />
    </SuccessModal>
  );
};

export default StartNextSurveyModal;
